import React, { useState, useEffect } from "react";
import api from "services/api";
import VipLevelText from "elements/VipLevelText";
import InputBox from "elements/InputBox";
import SelectBox from "elements/SelectBox";
import { Tabs, Tab, Form } from "react-bootstrap";
import UserLeftArea from "elements/dashboardElements/UserLeftArea";
import { __ } from "services/Translator";
import PageHeadline from "../PageHeadline";

export default function ProfileDetails(props) {
  const setSpinner = props.setSpinner;

  // const __ = (text) => text;

  const genders = [
    { label: __("Gender"), value: null },
    { label: __("Male"), value: "Male" },
    { label: __("Female"), value: "Female" },
    { label: __("Other"), value: "Other" },
  ];

  const [countries, setCountries] = useState([]);
  const [languages, setLanguages] = useState([]);
  const currencies = [
    { label: __("Currency"), value: null },
    { label: "USD", value: "USD" },
  ];
  const [phoneCodes, setPhoneCodes] = useState([]);

  const getCountries = async () => {
    var response = await api.get("/countries");
    if (response.status === 200) {
      setCountries(
        response.data.map((val) => {
          return { label: val.nicename, value: val.code };
        })
      );
      setPhoneCodes(
        response.data.map((val) => {
          return {
            label: "+" + val.phonecode + " (" + val.code + ")",
            value: "+" + val.phonecode,
          };
        })
      );
    } else {
      props.showAlert(null, response.data.message);
    }
  };

  const getLanguages = async () => {
    var response = await api.get("/languages");
    if (response.status === 200) {
      setLanguages(
        response.data.map((val) => {
          return { label: val.language, value: val.code };
        })
      );
    } else {
      props.showAlert(null, response.data.message);
    }
  };

  const getProfile = async () => {
    setSpinner(true);
    var response = await api.get("/profile");
    setSpinner(false);
    if (response.status === 200) {
      setForm(response.data);
      props.setIsAnonymous(parseInt(response.data.isAnonymous));
      setIsDataFetched(true);
    } else {
      props.showAlert(null, response.data.message);
    }
  };

  const [editMode, setEditMode] = useState(false);

  const submitProfile = async (ev) => {
    ev.preventDefault();
    setSpinner(true);
    var response = await api.post("/profile/save", {
      oldPassword: form.oldPassword,
      password: form.password,
      repassword: form.repassword,
    });
    setSpinner(false);
    if (response.status === 200) {
      props.showAlert("Success!!", response.data.message);
      setForm({
        ...form,
        oldPassword: "",
        password: "",
        repassword: "",
      });
      setIsDataFetched(true);
    } else {
      props.showAlert(null, response.data.message, true);
    }
  };

  const [isDataFetched, setIsDataFetched] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    country: "",
    dateOfBirth: "",
    gender: "",
    currency: "",
    language: "",
    phoneCode: "",
    phone: "",
  });

  const updateForm = (value, field) => {
    setForm({ ...form, [field]: value });
  };

  const getAllData = async (force) => {
    if (!isDataFetched || force) {
      setSpinner(true);
      await getCountries();
      await getLanguages();
      await getProfile();
      // setSpinner(false);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  //Switch action
  const toggleAnonymousSettings = async () => {
    props.setIsAnonymous(!parseInt(props.isAnonymous));

    props.setSpinner(true);
    var response = await api.post("/toggle-anonymous-settings", {
      isAnonymous: !props.isAnonymous,
    });
    props.setSpinner(false);
    if (response.status === 200) {
      props.showAlert("Success!!", response.data.message);
    } else {
      props.showAlert(null, response.data.message, true);
    }
  };

  const toggleTwoFASettings = async () => {
    setForm({ ...form, twoFaEnabled: !form.twoFaEnabled });
    props.setSpinner(true);
    var response = await api.post("/toggle-twofa-settings");
    props.setSpinner(false);
    if (response.status === 200) {
      props.showAlert("Success!!", response.data.message);
    } else {
      setForm({ ...form, twoFaEnabled: !!form.twoFaEnabled });
      props.showAlert(null, response.data.message, true);
    }
  };

  //Custom action for Tabs
  const editAccount = (e) => {
    props.sendDataToParent(e);
  };
  return (
    <>
      <PageHeadline page_name="Account Details" />

      <div className="credentials">
        <div className="credentials__primary">
          <div className="id_no">
            <span className="id_no__label">{__("Casino ID")}</span>
            <span className="id">{form.pin || "—"}</span>
          </div>
          <div className="edit_btn">
            <button
              type="button"
              onClick={() => {
                editAccount(true);
              }}
              className="commonBtn pTwoBtn credentials__edit-btn"
            >
              <span className="credentials__edit-btn-full">{__("Edit Account")}</span>
              <span className="credentials__edit-btn-short">{__("Edit")}</span>
            </button>
          </div>
        </div>
        <div className="credentials__settings">
          <div className="single_item switchItem">
            <span className="item_title">{__("Anonymous")}</span>
            <Form.Check
              className="form-check form-switch account-settings-switch"
              checked={props.isAnonymous}
              type="switch"
              onChange={toggleAnonymousSettings}
              id="anonymous_mode"
            />
          </div>
          <div className="single_item switchItem">
            <span className="item_title">{__("2FA")}</span>
            <Form.Check
              className="form-check form-switch account-settings-switch"
              checked={form.twoFaEnabled}
              type="switch"
              onChange={toggleTwoFASettings}
              id="twofa_mode"
            />
          </div>
        </div>
      </div>

      <div className="page_content_area profile-details-form">
        <div className="row">
          <div className="col-12 col-sm-6 col-md-6">
            <div className="input_item">
              <div className="name">{__("Name")}</div>
              <input
                className="form-control name_value"
                value={form.firstName + " " + form.lastName}
                type="text"
                readOnly={true}
              />
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6">
            <div className="input_item">
              <div className="name">{__("Email")}</div>
              <input
                className="form-control name_value"
                value={form.email}
                type="email"
                readOnly={true}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-sm-4 col-md-6 col-lg-4">
            <div className="input_item">
              <div className="name">{__("Birthday")}</div>
              <input
                className="form-control name_value select_box input_bg"
                value={form.dateOfBirth}
                type="text"
                readOnly={true}
              />
            </div>
          </div>
          <div className="col-6 col-sm-3 col-md-6 col-lg-3">
            <div className="input_item">
              <div className="name">{__("Phone Number")}</div>
              <input
                className="form-control name_value"
                value={form.phoneCode + " " + form.phone}
                type="phone"
                readOnly={true}
              />
            </div>
          </div>
          <div className="col-12 col-sm-5 col-md-12 col-lg-5">
            <div className="input_item">
              <div className="name">{__("Country")}</div>
              <input
                className="form-control name_value"
                value={
                  countries?.filter((item) => item.value === form.country)[0]
                    ?.label
                }
                type="text"
                readOnly={true}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6 col-sm-3 col-md-6 col-lg-3">
            <div className="input_item">
              <div className="name">{__("States")}</div>
              <input
                className="form-control name_value"
                value={form.state}
                type="text"
                readOnly={true}
              />
            </div>
          </div>
          <div className="col-6 col-sm-3 col-md-6 col-lg-3">
            <div className="input_item">
              <div className="name">{__("Zip Code")}</div>
              <input
                className="form-control name_value"
                value={form.zip}
                type="text"
                readOnly={true}
              />
            </div>
          </div>
          <div className="col-12 col-sm-6  col-md-12 col-lg-6">
            <div className="input_item">
              <div className="name">{__("Address")}</div>
              <input
                className="form-control name_value"
                value={form.address + (form.city ? ", " + form.city : "")}
                type="text"
                readOnly={true}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-sm-4 col-md-6 col-lg-4">
            <div className="input_item">
              <div className="name">{__("Currency")}</div>
              <input
                className="form-control name_value select_box input_bg"
                value={form.currency}
                type="text"
                readOnly={true}
              />
            </div>
          </div>
        </div>
        <h5 className="subTitle profile-password-title">{__("Update Password")}</h5>

        <div className="row">
          <div className="col-12 col-sm-4">
            <div className="input_item">
              <div className="name">{__("Old Password")}</div>
              <InputBox
                className="form-control name_value"
                value={form.oldPassword}
                onChange={(value) => updateForm(value, "oldPassword")}
                type="password"
              />
            </div>
          </div>
          <div className="col-12 col-sm-4">
            <div className="input_item">
              <div className="name">{__("New Password")}</div>
              <InputBox
                className="form-control name_value"
                value={form.password}
                onChange={(value) => updateForm(value, "password")}
                type="password"
              />
            </div>
          </div>
          <div className="col-12 col-sm-4">
            <div className="input_item">
              <div className="name">{__("Re-type Password")}</div>
              <InputBox
                className="form-control name_value"
                value={form.repassword}
                onChange={(value) => updateForm(value, "repassword")}
                type="password"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <button onClick={submitProfile} className="commonBtn pTwoBtn">
              {__("Update Password")}
            </button>
          </div>
        </div>
      </div>

      {/* <UserLeftArea section="Account Details" form={form} {...props} /> */}
    </>
  );
}
